import * as React from 'react'
import { StripeProvider, Elements } from 'react-stripe-elements'

function withStripeProvider<P>(Component: React.ComponentType<P>) {
  function WithStripeProvider(props: P) {
    // const publicKey = 'pk_test_P995J2iqC4UVUiRZ9kc2FWUk'
    const publicKey = 'pk_live_jXblTYHoNQtEVqa3Ib6gTnJc'

    return (
      <StripeProvider apiKey={publicKey}>
        <Elements>
          <Component {...props} />
        </Elements>
      </StripeProvider>
    )
  }

  WithStripeProvider.displayName = `WithStripeProvider(${Component.displayName ||
    Component.name})`

  return WithStripeProvider
}

export default withStripeProvider



// WEBPACK FOOTER //
// ./src/withStripeProvider.tsx